import { cn } from '@/lib/utils'
import { School } from '@mui/icons-material'
import { Chip } from '@mui/material'
import { CardModuleProps } from './@types'

export function View({
  module,
  className,
  ...props
}: Omit<CardModuleProps, 'variant'>) {
  const IconModule = module?.activeIcon ? (
    <img src={module?.activeIcon} className="!w-full  !h-full" alt="ícone" />
  ) : module?.disableIcon ? (
    <img src={module?.disableIcon} className="!w-full !h-full" alt="ícone" />
  ) : (
    <School className="!w-full !h-full" />
  )

  return (
    <article
      {...props}
      className={cn(
        className,
        'bg-tertiary hover:opacity-80 cursor-pointer text-center rounded-xl flex flex-col items-center justify-between gap-3 p-3 !w-[190px] !h-[174px]',
      )}
    >
      <Chip
        label={`Nível ${module?.level}`}
        className="!bg-[#4A4B52] !rounded-md !text-xs w-max max-w-full mr-auto"
        sx={{ '& > span': { fontWeight: '600' } }}
      />

      <div className="w-[6rem] h-6rem] rounded-lg overflow-hidden object-fill">
        {IconModule}
      </div>

      <h3 className="text-lg">{module?.name}</h3>
    </article>
  )
}
